export default "__VITE_ASSET__ByqaJB22__"